module.exports = __webpack_public_path__ + "static/media/nurse.53e39eda.jpg";